<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'

// There's no notification feed on the backend yet — the panel runs on an
// empty state; wire up the real source here once the API exists.
const items = ref([])

const open = ref(false)
const wrapRef = ref(null)
const unread = computed(() => items.value.filter((n) => n.unread).length)

function markAll() {
  items.value = items.value.map((n) => ({ ...n, unread: false }))
}
function markOne(id) {
  items.value = items.value.map((n) => (n.id === id ? { ...n, unread: false } : n))
}

function onDocClick(e) {
  if (open.value && wrapRef.value && !wrapRef.value.contains(e.target)) open.value = false
}
onMounted(() => document.addEventListener('mousedown', onDocClick))
onBeforeUnmount(() => document.removeEventListener('mousedown', onDocClick))
</script>

<template>
  <div ref="wrapRef" class="notif-wrap">
    <button class="iconbtn" type="button" title="Notifications" @click="open = !open">
      <span class="mdi mdi-bell-outline"></span>
      <span v-if="unread > 0" class="badge"></span>
    </button>
    <div v-if="open" class="notif-panel">
      <div class="notif-panel__head">
        <h3>Notifications</h3>
        <span v-if="unread > 0" class="count">{{ unread }}</span>
        <button v-if="unread > 0" class="notif-panel__markall" type="button" @click="markAll">
          Mark all as read
        </button>
      </div>
      <div v-if="items.length === 0" class="notif-empty">
        <span class="mdi mdi-bell-check-outline"></span>
        You’re all caught up.
      </div>
      <div v-else class="notif-list">
        <button
          v-for="n in items"
          :key="n.id"
          class="notif-item"
          :class="{ 'is-unread': n.unread }"
          type="button"
          @click="markOne(n.id)">
          <div class="notif-item__ico" :class="n.sev">
            <span class="mdi" :class="`mdi-${n.icon}`"></span>
          </div>
          <div class="notif-item__body">
            <b>{{ n.text }}</b>
            <span>{{ n.detail }}</span>
            <div class="notif-item__time">{{ n.time }}</div>
          </div>
          <span v-if="n.unread" class="notif-item__dot"></span>
        </button>
      </div>
    </div>
  </div>
</template>
